<template>
  <div
    class="sidebar-component"
    :style="{
      textShadow: _textShadow,
    }"
  >
    <Volume
      :agentGainer="$props.agentGainer"
      :droneGainer="$props.droneGainer"
      @agentGainerValueChange="onAgentGainerValueChange"
      @droneGainerValueChange="onDroneGainerValueChange"
    />
    <Time :nextEclipseDate="$props.nextEclipseDate" :nowDate="$props.nowDate" :elapsedTime="$props.elapsedTime" />
    <Population :lifeDeathRatios="$props.lifeDeathRatios" :agents="$props.agents" />
  </div>
</template>

<script>
import Volume from './sideBars/Volume.vue';
import Time from './sideBars/Time.vue';
import Population from './sideBars/Population.vue';

export default {
  props: {
    agentGainer: Object,
    droneGainer: Object,
    lifeDeathRatios: Object,
    agents: Array,
    nextEclipseDate: Date,
    nowDate: Date,
    elapsedTime: String,
    backgroundColor: String,
  },
  components: {
    Volume,
    Time,
    Population,
  },
  methods: {
    onAgentGainerValueChange(gainValue) {
      this.$emit('agentGainerValueChange', gainValue);
    },
    onDroneGainerValueChange(gainValue) {
      this.$emit('droneGainerValueChange', gainValue);
    },
  },
  computed: {
    _textShadow() {
      const spBreakPoint = 559;

      if (window.innerWidth < spBreakPoint) {
        return `1px 1px 0px ${this.$props.backgroundColor}, -1px 1px 0px ${this.$props.backgroundColor}, 1px -1px 0px ${this.$props.backgroundColor}, -1px -1px 0px ${this.$props.backgroundColor}, 1px 0px 0px ${this.$props.backgroundColor}, 0px 1px 0px ${this.$props.backgroundColor}, -1px 0px 0px ${this.$props.backgroundColor}, 0px -1px 0px ${this.$props.backgroundColor}`;
      }

      return 'none';
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-component {
  position: absolute;
  bottom: 154px;
  right: 23px;
  width: 400px;
}
</style>
